import './index.css';
const useInputAriaProps = ({ invalid, hasPlaceholder, hasDescription, descriptionId, labelId, }) => {
    const ariaProps = {};
    invalid && (ariaProps['aria-invalid'] = !!invalid);
    if (hasPlaceholder) {
        ariaProps['aria-labelledby'] = `input-label-${labelId}`;
    }
    if (hasDescription) {
        ariaProps['aria-describedby'] = `input-description-${descriptionId}`;
    }
    return ariaProps;
};

export { useInputAriaProps };
//# sourceMappingURL=useInputAriaProps.js.map
